function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "9",
  viewBox: "0 0 9 7",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M.535 3.062a.297.297 0 01.413 0l2.097 2.05L7.79.477a.297.297 0 01.413 0l.412.403a.28.28 0 010 .403l-5.362 5.24a.297.297 0 01-.413 0L.123 3.867a.28.28 0 010-.403l.412-.403z",
  fill: "#FFF",
  fillRule: "evenodd"
})));